export const FW_FUNNEL_DEFAULT_EXPIRE_TIME_SECONDS = 365 * 2 * 24 * 60 * 60 // 2 Years
